<!--
 * @Author: wsx
 * @Date: 2022-02-16 14:47:10
 * @LastEditTime: 2022-02-24 11:27:09
 * @Description:主视图
 * @FilePath: \hz-digital-twin\src\layout\components\MyMain\index.vue
-->
<template>
  <div class="MyMain">
    <router-view class="my-main-page" :key="key" />
  </div>
</template>
<script>
import { defineComponent, reactive, computed, toRefs } from "vue";

import { useRoute } from "vue-router";
export default defineComponent({
  name: "MyMain",
  setup() {
    const state = reactive({});
    const refData = toRefs(state);

    const route = useRoute();
    const key = computed(() => route.path);
    return { ...refData, key };
  }
});
</script>
<style lang="scss" scoped>
.MyMain {
  width: 100%;
  height: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  .my-main-page {
    width: 100%;
    height: 130%;
    position: relative;
    top: -13%;
    pointer-events: none;
  }
}
</style>
